// <s-store-status> reveals the server-rendered "open" or "closed" message based on the store's local time.
class SStoreStatus extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#update();
    this.#timer = setInterval(() => this.#update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #update() {
    const open = Number(this.dataset.open);
    const close = Number(this.dataset.close);
    if (!Number.isFinite(open) || !Number.isFinite(close)) return;

    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: this.dataset.timezone || 'America/New_York',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const hour = Number(parts.find((p) => p.type === 'hour')?.value);
    const minute = Number(parts.find((p) => p.type === 'minute')?.value);
    const now = hour + minute / 60;

    // Closing before opening means the store is open overnight.
    const isOpen = close > open ? now >= open && now < close : now >= open || now < close;

    this.querySelectorAll('[data-state]').forEach((el) => {
      el.hidden = el.dataset.state !== (isOpen ? 'open' : 'closed');
    });
    this.hidden = false;
  }
}

if (!customElements.get('s-store-status')) customElements.define('s-store-status', SStoreStatus);
